import {
  PLANBENEFITS_SUPPORTED_LANGUAGE,
} from './actionTypes';

export default function reducer(state = {}, action) {
  switch (action.type) {
    case PLANBENEFITS_SUPPORTED_LANGUAGE:
      return {
        ...state,
        languageId: action.languageId,
      };
    default:
      return state;
  }
}

// actions
export function updateLanguage(languageId) {
  return {
    type: PLANBENEFITS_SUPPORTED_LANGUAGE,
    languageId,
  };
}
